export default __webpack_public_path__ + "static/2-a1ca51c05c2fd24792fcb0f840469234.png";